var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { childrenPropType, TSS_BLUE } from 'tss-core-lib-common';
import { Icon, PrimaryButton, SecondaryButton, Modal, Dialog, DialogSubject, DialogHeading, DialogParagraph, DialogButtonRow, DialogContent } from '.';

import { IMG_ICON_WARNING_O_LARGE } from '../img';

export var ConfirmDialog = function ConfirmDialog(_ref) {
  var children = _ref.children,
      subject = _ref.subject,
      heading = _ref.heading,
      content = _ref.content,
      okLabel = _ref.okLabel,
      onOk = _ref.onOk,
      onCancel = _ref.onCancel;
  return React.createElement(
    Modal,
    null,
    React.createElement(
      Dialog,
      null,
      subject ? React.createElement(
        DialogSubject,
        null,
        subject
      ) : null,
      React.createElement(
        DialogHeading,
        null,
        React.createElement(Icon, { src: IMG_ICON_WARNING_O_LARGE, stroke: TSS_BLUE() })
      ),
      React.createElement(
        DialogHeading,
        null,
        heading
      ),
      content ? React.createElement(
        DialogParagraph,
        null,
        content
      ) : null,
      children ? React.createElement(
        DialogContent,
        null,
        children
      ) : null,
      React.createElement(
        DialogButtonRow,
        null,
        React.createElement(
          PrimaryButton,
          { onClick: onOk },
          okLabel || React.createElement(FormattedMessage, { id: 'label.ok' })
        ),
        React.createElement(
          SecondaryButton,
          { onClick: onCancel },
          React.createElement(FormattedMessage, { id: 'label.cancel' })
        )
      )
    )
  );
};

ConfirmDialog.propTypes = {
  children: childrenPropType,
  subject: PropTypes.string,
  okLabel: PropTypes.string,
  heading: PropTypes.string.isRequired,
  content: PropTypes.string,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
};

ConfirmDialog.defaultProps = {
  children: null,
  okLabel: null,
  subject: null,
  content: null,
  error: false,
  warning: false
};

export var withConfirmDialog = function withConfirmDialog(Comp) {
  return function (_React$Component) {
    _inherits(_class2, _React$Component);

    function _class2() {
      var _ref2;

      var _temp, _this, _ret;

      _classCallCheck(this, _class2);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = _class2.__proto__ || Object.getPrototypeOf(_class2)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {}, _this.confirm = function (_ref3) {
        var subject = _ref3.subject,
            heading = _ref3.heading,
            content = _ref3.content,
            okLabel = _ref3.okLabel;
        return new Promise(function (resolve) {
          _this.setState({
            message: { subject: subject, heading: heading, content: content, okLabel: okLabel },
            onOk: function onOk() {
              _this.setState({ message: null });
              resolve(true);
            },
            onCancel: function onCancel() {
              _this.setState({ message: null });
              resolve(false);
            }
          });
        });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(_class2, [{
      key: 'render',
      value: function render() {
        return React.createElement(
          Fragment,
          null,
          React.createElement(Comp, Object.assign({}, this.props, { confirm: this.confirm })),
          this.state.message ? React.createElement(ConfirmDialog, Object.assign({}, this.state.message, { onOk: this.state.onOk, onCancel: this.state.onCancel })) : null
        );
      }
    }]);

    return _class2;
  }(React.Component);
};